import { render, staticRenderFns } from "./DistributionListForm.vue?vue&type=template&id=1976725e&"
import script from "./DistributionListForm.vue?vue&type=script&lang=js&"
export * from "./DistributionListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports